/// <reference path="../../../../../typings/index.d.ts" />
var app;
(function (app) {
    var common;
    (function (common) {
        "use strict";
        angular
            .module("app.common", [
            "ngAnimate",
            "ui.bootstrap",
            "ui.router",
            "LocalStorageModule",
            "angular-monash"
        ]);
    })(common = app.common || (app.common = {}));
})(app || (app = {}));
//# sourceMappingURL=app.common.js.map
var app;
(function (app) {
    var common;
    (function (common) {
        "use strict";
        var IeCacheFix = (function () {
            function IeCacheFix($httpProvider) {
                // Initialize http get header defaults if required
                if (!$httpProvider.defaults.headers.get) {
                    $httpProvider.defaults.headers.get = {};
                }
                // Disable IE ajax request caching
                $httpProvider.defaults.headers.get["If-Modified-Since"] = 0;
            }
            IeCacheFix.$inject = ["$httpProvider"];
            return IeCacheFix;
        })();
        var TemplateCacheBuster = (function () {
            function TemplateCacheBuster($provide) {
                var cacheBuster = Date.now().toString();
                function templateFactoryDecorator($delegate) {
                    var fromUrl = angular.bind($delegate, $delegate.fromUrl);
                    $delegate.fromUrl = function (url, params) {
                        if (url !== null && angular.isDefined(url) && angular.isString(url)) {
                            url += (url.indexOf("?") === -1 ? "?" : "&");
                            url += "v=" + cacheBuster;
                        }
                        return fromUrl(url, params);
                    };
                    return $delegate;
                }
                $provide.decorator("$templateFactory", ["$delegate", templateFactoryDecorator]);
            }
            TemplateCacheBuster.$inject = ["$provide"];
            return TemplateCacheBuster;
        })();
        angular
            .module("app.common")
            .config(IeCacheFix)
            .config(TemplateCacheBuster);
    })(common = app.common || (app.common = {}));
})(app || (app = {}));
//# sourceMappingURL=app.common.config.js.map
var app;
(function (app) {
    var common;
    (function (common) {
        "use strict";
        var Calculator = (function () {
            function Calculator() {
                this.bindings = {
                    institutions: "<institutions"
                };
                this.controller = CalculatorController;
                this.templateUrl = "/static/templates/common/calculator.html";
            }
            return Calculator;
        })();
        common.Calculator = Calculator;
        var Unit = (function () {
            function Unit() {
            }
            return Unit;
        })();
        var CalculatorController = (function () {
            function CalculatorController($log) {
                this.$log = $log;
                this.units = [];
                $log.debug("institutions");
                $log.debug(this.institutions);
            }
            CalculatorController.prototype.resetForm = function () {
                this.selectedInstitution = null;
                this.units = [new Unit()];
            };
            CalculatorController.prototype.calculateAverageGpa = function () {
                var _this = this;
                if (!this.units || this.units.length === 0) {
                    this.creditTotal = 0;
                    return 0;
                }
                var gradeValueQuantityTuple = this.units
                    .map(function (unit) {
                    if (!unit.quantity || unit.quantity === 0) {
                        _this.creditTotal = 0;
                        return [0, 0];
                    }
                    return [unit.grade.value * unit.quantity, unit.quantity];
                })
                    .reduce(function (total, value) {
                    _this.creditTotal = total[1] + value[1];
                    return [total[0] + value[0], total[1] + value[1]];
                });
                if (!gradeValueQuantityTuple[1] || gradeValueQuantityTuple[1] === 0) {
                    return 0;
                }
                return gradeValueQuantityTuple[0] / gradeValueQuantityTuple[1];
            };
            CalculatorController.$inject = ["$log"];
            return CalculatorController;
        })();
        angular
            .module("app.common")
            .component("calculator", new Calculator());
    })(common = app.common || (app.common = {}));
})(app || (app = {}));
//# sourceMappingURL=calculatorComponent.js.map
var app;
(function (app) {
    var common;
    (function (common) {
        "use strict";
        var Institution = (function () {
            function Institution() {
                this.grades = [];
            }
            return Institution;
        })();
        common.Institution = Institution;
        var Grade = (function () {
            function Grade() {
            }
            return Grade;
        })();
        common.Grade = Grade;
    })(common = app.common || (app.common = {}));
})(app || (app = {}));
//# sourceMappingURL=Institution.js.map
var app;
(function (app) {
    var common;
    (function (common) {
        "use strict";
        var User = (function () {
            function User(username, email, firstName, lastName, isStaff) {
                this.username = username;
                this.email = email;
                this.firstName = firstName;
                this.lastName = lastName;
                this.isStaff = isStaff;
            }
            return User;
        })();
        common.User = User;
    })(common = app.common || (app.common = {}));
})(app || (app = {}));
//# sourceMappingURL=User.js.map
var app;
(function (app) {
    var common;
    (function (common) {
        "use strict";
        var AuthService = (function () {
            function AuthService($http, $log) {
                this.$http = $http;
                this.$log = $log;
            }
            AuthService.prototype.getCurrentUser = function () {
                return this.$http.get("/api/currentUser").then(function (response) { return response.data; });
            };
            AuthService.prototype.logout = function () {
                return this.$http.post("/api/logout", {}).then(function (response) { return response.data; });
            };
            AuthService.$inject = ["$http", "$log"];
            return AuthService;
        })();
        angular
            .module("app.common")
            .service("authService", AuthService);
    })(common = app.common || (app.common = {}));
})(app || (app = {}));
//# sourceMappingURL=authService.js.map
var app;
(function (app) {
    var common;
    (function (common) {
        "use strict";
        var InstitutionService = (function () {
            function InstitutionService($http, $log) {
                this.$http = $http;
                this.$log = $log;
            }
            InstitutionService.prototype.getInstitutions = function () {
                return this.$http.get("/api/institutions").then(function (response) { return response.data; });
            };
            InstitutionService.prototype.getInstitution = function (id) {
                return this.$http.get("/api/institutions/" + id).then(function (response) { return response.data; });
            };
            InstitutionService.prototype.createInstitution = function (institution) {
                return this.$http.post("/api/institutions", institution).then(function (response) { return response.data; });
            };
            InstitutionService.prototype.saveInstitution = function (institution) {
                return this.$http.put("/api/institutions/" + institution.id, institution).then(function (response) { return response.data; });
            };
            InstitutionService.prototype.deleteInstitution = function (id) {
                return this.$http.delete("/api/institutions/" + id).then(function (response) { return response.data; });
            };
            InstitutionService.$inject = ["$http", "$log"];
            return InstitutionService;
        })();
        angular
            .module("app.common")
            .service("institutionService", InstitutionService);
    })(common = app.common || (app.common = {}));
})(app || (app = {}));
//# sourceMappingURL=institutionService.js.map
/// <reference path="../../../../../typings/index.d.ts" />
var app;
(function (app) {
    var pub;
    (function (pub) {
        "use strict";
        var Routes = (function () {
            Routes.$inject = ["$stateProvider", "$urlRouterProvider"];
            function Routes($stateProvider, $urlRouterProvider) {
                $urlRouterProvider.otherwise("/");
                $stateProvider
                    .state("pub-home", {
                    component: "calculator",
                    resolve: {
                        institutions: ["institutionService", function (institutionService) {
                                return institutionService.getInstitutions();
                            }]
                    },
                    url: "/"
                });
            }
            return Routes;
        })();
        angular
            .module("app.pub", ["app.common"])
            .config(Routes);
    })(pub = app.pub || (app.pub = {}));
})(app || (app = {}));
//# sourceMappingURL=app.pub.js.map
var app;
(function (app) {
    var staff;
    (function (staff) {
        "use strict";
        var Institution = app.common.Institution;
        var Routes = (function () {
            Routes.$inject = ["$stateProvider", "$urlRouterProvider"];
            function Routes($stateProvider, $urlRouterProvider) {
                $urlRouterProvider.otherwise("/");
                $stateProvider
                    .state("staff-home", {
                    component: "calculator",
                    resolve: {
                        institutions: ["institutionService", function (institutionService) {
                                return institutionService.getInstitutions();
                            }]
                    },
                    url: "/"
                })
                    .state("config-institutions", {
                    component: "institutionList",
                    resolve: {
                        institutions: ["institutionService", function (institutionService) {
                                return institutionService.getInstitutions();
                            }],
                        user: ["authService", function (authService) {
                                return authService.getCurrentUser();
                            }]
                    },
                    url: "/institutions"
                })
                    .state("config-institutions.add", {
                    onEnter: ["$log", "$stateParams", "$state", "$uibModal", "institution", function ($log, $stateParams, $state, $uibModal, institution) {
                        $uibModal.open({
                            component: "institutionAddModal",
                            resolve: {
                                institution: function () { return institution; }
                            }
                        }).result
                            .then(function (result) {
                            $log.debug(result);
                            $state.go("^", null, { reload: true });
                        }, function (reason) {
                            $log.debug(reason);
                            $state.go("^");
                        });
                    }],
                    onExit: ["$uibModalStack", function ($uibModalStack) {
                        $uibModalStack.dismissAll();
                    }],
                    resolve: {
                        institution: function () { return new Institution(); }
                    },
                    url: "/add"
                })
                    .state("config-institutions.edit", {
                    onEnter: ["$log", "$stateParams", "$state", "$uibModal", "institution", function ($log, $stateParams, $state, $uibModal, institution) {
                        $uibModal.open({
                            component: "institutionEditModal",
                            resolve: {
                                institution: function () { return institution; }
                            },
                        }).result
                            .then(function (result) {
                            $log.debug(result);
                            $state.go("^", null, { reload: true });
                        }, function (reason) {
                            $log.debug(reason);
                            $state.go("^");
                        });
                    }],
                    onExit: ["$uibModalStack", function ($uibModalStack) {
                        $uibModalStack.dismissAll();
                    }],
                    resolve: {
                        institution: ["$stateParams", "institutionService", function ($stateParams, institutionService) {
                                return institutionService.getInstitution($stateParams.id);
                            }]
                    },
                    url: "/:id"
                })
                    .state("config-upload-csv", {
                    templateUrl: "/static/templates/staff/institution-csv.html",
                    url: "/institutions-csv"
                });
            }
            return Routes;
        })();
        angular
            .module("app.staff", ["app.common"])
            .config(Routes);
    })(staff = app.staff || (app.staff = {}));
})(app || (app = {}));
//# sourceMappingURL=app.staff.js.map
/// <reference path="../../../../../typings/index.d.ts" />
var Admin;
(function (Admin) {
    "use strict";
    angular
        .module("admin", [
        "ngAnimate",
        "ui.bootstrap",
        "ui.router",
        "LocalStorageModule",
        "ngFileUpload",
        "angular-monash",
        "monash-user-admin-ui"
    ]);
})(Admin || (Admin = {}));
//# sourceMappingURL=admin.js.map
var Admin;
(function (Admin) {
    "use strict";
    var AdminRoutes = (function () {
        AdminRoutes.$inject = ["$stateProvider", "$urlRouterProvider"];
        function AdminRoutes($stateProvider, $urlRouterProvider) {
            $urlRouterProvider.otherwise("/login");
            $stateProvider
                .state("login", {
                component: "login",
                url: "/login"
            });
        }
        return AdminRoutes;
    })();
    angular
        .module("admin")
        .config(AdminRoutes);
})(Admin || (Admin = {}));
//# sourceMappingURL=admin.routes.js.map
var app;
(function (app) {
    var pub;
    (function (pub) {
        "use strict";
        var PublicApp = (function () {
            function PublicApp() {
                this.controller = AppController;
                this.templateUrl = "/static/templates/public/public-app.html";
            }
            return PublicApp;
        })();
        pub.PublicApp = PublicApp;
        var AppController = (function () {
            // @ngInject
            AppController.$inject = ["$log", "$uibModal"];
            function AppController($log, $uibModal) {
                this.$log = $log;
                this.$uibModal = $uibModal;
                this.appName = "GPA Calculator";
                $log.debug("uibModal service: ", $uibModal);
                $uibModal.open({
                    templateUrl: "/static/templates/public/disclaimer.html"
                });
            }
            return AppController;
        })();
        angular
            .module("app.pub")
            .component("publicApp", new PublicApp());
    })(pub = app.pub || (app.pub = {}));
})(app || (app = {}));
//# sourceMappingURL=publicAppComponent.js.map
var app;
(function (app) {
    var staff;
    (function (staff) {
        "use strict";
        var InstitutionList = (function () {
            function InstitutionList() {
                this.bindings = {
                    institutions: "<",
                    user: "<"
                };
                this.controller = InstitutionListController;
                this.templateUrl = "/static/templates/staff/institution-list.html";
            }
            return InstitutionList;
        })();
        staff.InstitutionList = InstitutionList;
        var InstitutionListController = (function () {
            function InstitutionListController($log, institutionService) {
                this.$log = $log;
                this.institutionService = institutionService;
            }
            InstitutionListController.prototype.removeInstitution = function (index) {
                if (index > -1) {
                    this.$log.debug("removeInstitution(), id: %o", this.institutions[index].id);
                    this.institutionService.deleteInstitution(this.institutions[index].id);
                    this.institutions.splice(index, 1);
                }
            };
            InstitutionListController.$inject = ["$log", "institutionService"];
            return InstitutionListController;
        })();
        staff.InstitutionListController = InstitutionListController;
        angular
            .module("app.staff")
            .component("institutionList", new InstitutionList());
    })(staff = app.staff || (app.staff = {}));
})(app || (app = {}));
//# sourceMappingURL=institutionListComponent.js.map
var app;
(function (app) {
    var staff;
    (function (staff) {
        "use strict";
        var Grade = app.common.Grade;
        var InstitutionModal = (function () {
            // See Component section in https://angular-ui.github.io/bootstrap/#/ui-router-resolves
            function InstitutionModal() {
                this.bindings = {
                    modalInstance: "<",
                    resolve: "<"
                };
                this.controller = InstitutionModalController;
                this.templateUrl = "/static/templates/staff/institution-modal.html";
            }
            return InstitutionModal;
        })();
        staff.InstitutionModal = InstitutionModal;
        var InstitutionModalController = (function () {
            function InstitutionModalController($log, institutionService) {
                this.$log = $log;
                this.institutionService = institutionService;
            }
            InstitutionModalController.prototype.$onInit = function () {
                this.institution = this.resolve.institution;
                this.$log.debug(this.institution);
            };
            InstitutionModalController.prototype.submit = function () {
                var _this = this;
                this.$log.debug("submit");
                this.institution.grades = this.removeEmpty(this.institution.grades);
                if (this.institution.id) {
                    this.institutionService.saveInstitution(this.institution).then(function (institution) {
                        _this.modalInstance.close(institution);
                    });
                }
                else {
                    this.institutionService.createInstitution(this.institution).then(function (institution) {
                        _this.modalInstance.close(institution);
                    });
                }
            };
            InstitutionModalController.prototype.dismiss = function () {
                this.$log.debug("dismiss");
                this.modalInstance.close("cancelled");
            };
            InstitutionModalController.prototype.addGrade = function () {
                this.institution.grades.push(new Grade());
            };
            InstitutionModalController.prototype.removeGrade = function (index) {
                if (index > -1) {
                    this.institution.grades.splice(index, 1);
                }
            };
            InstitutionModalController.prototype.removeEmpty = function (grades) {
                var temp = [];
                for (var _i = 0; _i < grades.length; _i++) {
                    var grade = grades[_i];
                    if (grade.grade && grade.value >= 0) {
                        temp.push(grade);
                    }
                }
                return temp;
            };
            InstitutionModalController.$inject = ["$log", "institutionService"];
            return InstitutionModalController;
        })();
        staff.InstitutionModalController = InstitutionModalController;
        angular
            .module("app.staff")
            .component("institutionAddModal", new InstitutionModal());
        angular
            .module("app.staff")
            .component("institutionEditModal", new InstitutionModal());
    })(staff = app.staff || (app.staff = {}));
})(app || (app = {}));
//# sourceMappingURL=institutionModalComponent.js.map
var app;
(function (app) {
    var staff;
    (function (staff) {
        "use strict";
        var StaffApp = (function () {
            function StaffApp() {
                this.controller = StaffAppController;
                this.templateUrl = "/static/templates/staff/staff-app.html";
            }
            return StaffApp;
        })();
        staff.StaffApp = StaffApp;
        var StaffAppController = (function () {
            // @ngInject
            StaffAppController.$inject = ["authService"];
            function StaffAppController(authService) {
                var _this = this;
                this.authService = authService;
                this.appName = "GPA Calculator - Staff";
                this.authService.getCurrentUser().then(function (user) {
                    _this.user = user;
                    _this.leftNav = [
                        {
                            hide: !_this.user.isStaff,
                            items: [
                                {
                                    label: "Institutions",
                                    state: "config-institutions"
                                },
                                {
                                    label: "Upload institutions csv",
                                    state: "config-upload-csv"
                                }
                            ],
                            label: "Config"
                        }
                    ];
                });
            }
            return StaffAppController;
        })();
        angular
            .module("app.staff")
            .component("staffApp", new StaffApp());
    })(staff = app.staff || (app.staff = {}));
})(app || (app = {}));
//# sourceMappingURL=staffAppComponent.js.map